export function SummaryIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 7.5V3.5H14V7.5C14 8.32842 14.6716 9 15.5 9H19.5V10H15.5C14.1193 10 13 8.88071 13 7.5Z"
            fill="#2D70E2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 9.32842C19 8.9306 18.842 8.54907 18.5607 8.26777L14.7322 4.43934C14.4509 4.15803 14.0694 4 13.6716 4L7.5 4.00002C6.67157 4.00002 6 4.67159 6 5.50001V19.5C6 20.3284 6.67157 21 7.5 21H17.5C18.3284 21 19 20.3284 19 19.5V9.32842ZM19.2678 7.56066C19.7366 8.0295 20 8.66538 20 9.32842V19.5C20 20.8807 18.8807 22 17.5 22H7.5C6.11929 22 5 20.8807 5 19.5V5.50001C5 4.1193 6.11928 3.00002 7.49999 3.00002L13.6716 3C14.3346 3 14.9705 3.26339 15.4393 3.73223L19.2678 7.56066Z"
            fill="#2D70E2"
          />
        </g>
      </g>
    </svg>
  );
}

export function LightningIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="_Path_ (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9469 2.88303C13.9469 2.88307 13.9463 2.88384 13.9452 2.88522C13.9463 2.88369 13.9469 2.883 13.9469 2.88303ZM13.2179 2.67948C13.2179 2.67947 13.218 2.6801 13.2181 2.68144ZM13.2185 3.9891L7.28593 13.0037H10.8669C11.3779 13.0037 11.7815 13.4227 11.7815 13.912V19.0122L17.7141 9.9976H14.1331C13.6221 9.9976 13.2185 9.57856 13.2185 9.08925V3.9891ZM11.0531 20.1182C11.0531 20.1182 11.0537 20.1174 11.0548 20.116C11.0537 20.1176 11.0531 20.1183 11.0531 20.1182ZM11.7819 20.3198C11.7821 20.3211 11.7821 20.3217 11.7821 20.3218ZM14.1975 2.39943C14.234 2.50418 14.2422 2.61013 14.2422 2.69505V8.9976H18.2489C18.4607 8.9976 18.7647 9.07279 18.9214 9.36186C19.0758 9.64681 18.974 9.93245 18.8613 10.1037L11.9212 20.6492C11.875 20.7193 11.8086 20.8053 11.7167 20.8744C11.6335 20.9369 11.4318 21.0543 11.1775 20.9743C10.9297 20.8963 10.8344 20.6934 10.8025 20.6018C10.766 20.4971 10.7578 20.3911 10.7578 20.3062V14.0037H6.7511C6.53927 14.0037 6.23533 13.9285 6.07863 13.6394C5.92416 13.3544 6.02604 13.0688 6.13873 12.8976L13.0788 2.35202C13.125 2.28192 13.1914 2.19594 13.2833 2.12683C13.3665 2.06437 13.5682 1.94699 13.8225 2.02697C14.0703 2.10491 14.1656 2.3079 14.1975 2.39943Z"
          fill="#2D70E2"
        />
      </g>
    </svg>
  );
}

export function ILIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            d="M19.3111 17.0751C19.1214 17.0751 18.9617 17.0122 18.8319 16.8863C18.7021 16.7605 18.6372 16.6056 18.6372 16.4217V10.1932C18.6372 10.0093 18.7021 9.85447 18.8319 9.72864C18.9617 9.59313 19.1214 9.52538 19.3111 9.52538C19.5108 9.52538 19.6755 9.58829 19.8053 9.71412C19.9351 9.83995 20 9.99965 20 10.1932V16.4217C20 16.6056 19.9301 16.7605 19.7903 16.8863C19.6605 17.0122 19.5008 17.0751 19.3111 17.0751Z"
            fill={fill}
          />
          <path
            d="M18.8265 8.03815C18.9526 8.16048 19.1041 8.22165 19.2807 8.22165H19.3564C19.5331 8.22165 19.6845 8.16048 19.8107 8.03815C19.9369 7.91581 20 7.76901 20 7.59774V7.54881C20 7.37754 19.9369 7.23074 19.8107 7.10841C19.6845 6.98607 19.5331 6.9249 19.3564 6.9249H19.2807C19.1041 6.9249 18.9526 6.98607 18.8265 7.10841C18.7003 7.23074 18.6372 7.37754 18.6372 7.54881V7.59774C18.6372 7.76901 18.7003 7.91581 18.8265 8.03815Z"
            fill={fill}
          />
          <path
            d="M4.68889 6.92805C4.87859 6.92805 5.03833 6.99092 5.16812 7.11666C5.29791 7.2424 5.36281 7.39715 5.36281 7.58093V13.805C5.36281 13.9888 5.29791 14.1435 5.16812 14.2693C5.03833 14.4047 4.87859 14.4724 4.68889 14.4724C4.48921 14.4724 4.32448 14.4095 4.19469 14.2838C4.06489 14.1581 4 13.9985 4 13.805V7.58093C4 7.39715 4.06989 7.2424 4.20966 7.11666C4.33945 6.99092 4.4992 6.92805 4.68889 6.92805Z"
            fill={fill}
          />
          <path
            d="M5.17355 15.9594C5.04736 15.8372 4.89593 15.7761 4.71927 15.7761H4.64356C4.4669 15.7761 4.31547 15.8372 4.18929 15.9594C4.0631 16.0817 4 16.2284 4 16.3995V16.4484C4 16.6196 4.0631 16.7663 4.18929 16.8885C4.31547 17.0108 4.4669 17.0719 4.64356 17.0719H4.71927C4.89593 17.0719 5.04736 17.0108 5.17355 16.8885C5.29974 16.7663 5.36283 16.6196 5.36283 16.4484V16.3995C5.36283 16.2284 5.29974 16.0817 5.17355 15.9594Z"
            fill={fill}
          />
          <path
            d="M14.9786 4.9657C14.9786 4.60086 15.2836 4.3051 15.66 4.3051C16.0363 4.3051 16.3414 4.60086 16.3414 4.9657V19.0343C16.3414 19.3991 16.0363 19.6949 15.66 19.6949C15.2836 19.6949 14.9786 19.3991 14.9786 19.0343V4.9657Z"
            fill={fill}
          />
          <path
            d="M7.66131 4.9657C7.66131 4.60086 7.96638 4.3051 8.34271 4.3051C8.71904 4.3051 9.02412 4.60086 9.02412 4.9657V19.0343C9.02412 19.3991 8.71904 19.6949 8.34271 19.6949C7.96638 19.6949 7.66131 19.3991 7.66131 19.0343V4.9657Z"
            fill={fill}
          />
          <path
            d="M11.3199 3.6606C11.3199 3.29576 11.625 3 12.0013 3C12.3777 3 12.6827 3.29576 12.6827 3.6606V10.6876C12.6827 11.0525 12.3777 11.3482 12.0013 11.3482C11.625 11.3482 11.3199 11.0525 11.3199 10.6876V3.6606Z"
            fill={fill}
          />
          <path
            d="M11.3199 13.3124C11.3199 12.9475 11.625 12.6518 12.0013 12.6518C12.3777 12.6518 12.6827 12.9475 12.6827 13.3124V20.3394C12.6827 20.7042 12.3777 21 12.0013 21C11.625 21 11.3199 20.7042 11.3199 20.3394V13.3124Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export function ChevronIcon(fill) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 13L7 7L1 1" stroke="#666D79" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronDownIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64645 9.64062C7.84171 9.45313 8.15829 9.45313 8.35355 9.64062L12 13.142L15.6464 9.64062C15.8417 9.45313 16.1583 9.45313 16.3536 9.64062C16.5488 9.82812 16.5488 10.1321 16.3536 10.3196L12 14.5L7.64645 10.3196C7.45118 10.1321 7.45118 9.82812 7.64645 9.64062Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function ChevronUpIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.3536 14.3594C16.1583 14.5469 15.8417 14.5469 15.6464 14.3594L12 10.858L8.35355 14.3594C8.15829 14.5469 7.84171 14.5469 7.64645 14.3594C7.45118 14.1719 7.45118 13.8679 7.64645 13.6804L12 9.5L16.3536 13.6804C16.5488 13.8679 16.5488 14.1719 16.3536 14.3594Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function UserAvatar(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Stroke 1 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.39033 5.56245C8.82476 6.26949 8.5 7.38691 8.5 9C8.5 11.3784 9.20596 12.5161 9.75911 13.1799C9.88498 13.3309 10.0046 13.4593 10.1195 13.5827C10.1375 13.602 10.1553 13.6212 10.173 13.6402C10.2948 13.7714 10.4316 13.9204 10.53 14.0734C10.6329 14.2336 10.7319 14.4555 10.697 14.7244C10.6632 14.9852 10.516 15.1911 10.3536 15.3536C9.79738 15.9097 9.11646 16.3133 8.44236 16.6503C8.10429 16.8194 7.75972 16.9756 7.42895 17.1254L7.4213 17.1288C7.09015 17.2788 6.77365 17.4222 6.47361 17.5722C5.86371 17.8772 5.3703 18.1869 5.02853 18.5681C4.70175 18.9326 4.5 19.3773 4.5 20C4.5 20.2761 4.27614 20.5 4 20.5C3.72386 20.5 3.5 20.2761 3.5 20C3.5 19.1227 3.79825 18.4424 4.28397 17.9006C4.7547 17.3756 5.38629 16.9978 6.02639 16.6778C6.34375 16.5191 6.67518 16.369 7.00013 16.2218L7.01636 16.2145C7.34965 16.0635 7.67696 15.915 7.99514 15.7559C8.63354 15.4367 9.20262 15.0903 9.64645 14.6464C9.66218 14.6307 9.67437 14.6174 9.68374 14.6064C9.64067 14.5416 9.56727 14.4575 9.44024 14.3207C9.42405 14.3033 9.4072 14.2852 9.38978 14.2665C9.27529 14.1436 9.13582 13.994 8.99089 13.8201C8.29404 12.9839 7.5 11.6216 7.5 9C7.5 7.28009 7.84174 5.89751 8.60942 4.9378C9.39416 3.95677 10.5561 3.5 12 3.5C13.4439 3.5 14.6058 3.95677 15.3906 4.9378C16.1583 5.89751 16.5 7.28009 16.5 9C16.5 11.6216 15.706 12.9839 15.0091 13.8201C14.8642 13.994 14.7247 14.1437 14.6102 14.2665C14.5928 14.2852 14.5759 14.3033 14.5598 14.3207C14.4327 14.4575 14.3593 14.5416 14.3163 14.6064C14.3256 14.6174 14.3378 14.6307 14.3536 14.6464C14.7974 15.0903 15.3665 15.4367 16.0049 15.7559C16.323 15.915 16.6503 16.0635 16.9836 16.2145L16.9999 16.2218C17.3248 16.369 17.6563 16.5191 17.9736 16.6778C18.6137 16.9978 19.2453 17.3756 19.716 17.9006C20.2018 18.4424 20.5 19.1227 20.5 20C20.5 20.2761 20.2761 20.5 20 20.5C19.7239 20.5 19.5 20.2761 19.5 20C19.5 19.3773 19.2982 18.9326 18.9715 18.5681C18.6297 18.1869 18.1363 17.8772 17.5264 17.5722C17.2263 17.4222 16.9098 17.2788 16.5787 17.1288L16.571 17.1254C16.2403 16.9756 15.8957 16.8194 15.5576 16.6503C14.8835 16.3133 14.2026 15.9097 13.6464 15.3536C13.484 15.1911 13.3368 14.9852 13.303 14.7244C13.2681 14.4555 13.3671 14.2336 13.47 14.0734C13.5684 13.9204 13.7052 13.7714 13.827 13.6402C13.8447 13.6211 13.8625 13.602 13.8805 13.5827C13.9954 13.4593 14.115 13.3309 14.2409 13.1799C14.794 12.5161 15.5 11.3784 15.5 9C15.5 7.38691 15.1752 6.26949 14.6097 5.56245C14.0612 4.87673 13.2231 4.5 12 4.5C10.7769 4.5 9.93884 4.87673 9.39033 5.56245ZM14.2913 14.6498C14.2913 14.6498 14.2913 14.6497 14.2915 14.6493Z"
          fill="#2D70E2"
        />
      </g>
    </svg>
  );
}

export function CloseIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.14272 6.14272C6.333 5.95243 6.64152 5.95243 6.83181 6.14272L17.8573 17.1682C18.0476 17.3585 18.0476 17.667 17.8573 17.8573C17.667 18.0476 17.3585 18.0476 17.1682 17.8573L6.14272 6.83181C5.95243 6.64152 5.95243 6.333 6.14272 6.14272Z"
            fill="#2A3039"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.8573 6.14272C18.0476 6.333 18.0476 6.64152 17.8573 6.83181L6.83181 17.8573C6.64152 18.0476 6.333 18.0476 6.14272 17.8573C5.95243 17.667 5.95243 17.3585 6.14272 17.1682L17.1682 6.14272C17.3585 5.95243 17.667 5.95243 17.8573 6.14272Z"
            fill="#2A3039"
          />
        </g>
      </g>
    </svg>
  );
}

export function StarIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0016 2.5C12.1919 2.5 12.3657 2.60805 12.4499 2.77872L15.242 8.43601L21.4852 9.3432C21.6735 9.37056 21.83 9.50248 21.8888 9.68349C21.9476 9.8645 21.8985 10.0632 21.7623 10.196L17.2446 14.5996L18.3111 20.8176C18.3433 21.0052 18.2662 21.1948 18.1122 21.3066C17.9582 21.4185 17.7541 21.4332 17.5856 21.3447L12.0016 18.409L6.41748 21.3447C6.24902 21.4332 6.04489 21.4185 5.89091 21.3066C5.73694 21.1948 5.65983 21.0052 5.692 20.8176L6.75847 14.5996L2.24085 10.196C2.10457 10.0632 2.05552 9.8645 2.11433 9.68349C2.17314 9.50248 2.32962 9.37056 2.51796 9.3432L8.76115 8.43601L11.5532 2.77872C11.6374 2.60805 11.8112 2.5 12.0016 2.5ZM12.0016 4.12978L9.54155 9.11429C9.46872 9.26187 9.32794 9.36415 9.16508 9.38781L3.66434 10.1871L7.64471 14.067C7.76256 14.1819 7.81633 14.3474 7.78851 14.5096L6.84887 19.9881L11.7689 17.4015C11.9145 17.3249 12.0886 17.3249 12.2342 17.4015L17.1542 19.9881L16.2146 14.5096C16.1868 14.3474 16.2406 14.1819 16.3584 14.067L20.3388 10.1871L14.838 9.38781C14.6752 9.36415 14.5344 9.26187 14.4616 9.11429L12.0016 4.12978Z"
        fill="#1D9A7D"
      />
    </svg>
  );
}

export function PieChartIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.5238 2.9647C6.7483 3.21232 2.95238 7.16287 2.95238 12C2.95238 16.9969 7.00314 21.0476 12 21.0476C16.8371 21.0476 20.7877 17.2517 21.0353 12.4762H11.5238V2.9647ZM12.4762 2.9647V11.5238H21.0353C20.7959 6.906 17.094 3.20415 12.4762 2.9647Z"
          fill="#FEA711"
        />
      </g>
    </svg>
  );
}

export function TrendsIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 13 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3536 6.64645C21.5488 6.84171 21.5488 7.15829 21.3536 7.35355L13.3536 15.3536C13.1583 15.5488 12.8417 15.5488 12.6464 15.3536L9 11.7071L3.35355 17.3536C3.15829 17.5488 2.84171 17.5488 2.64645 17.3536C2.45118 17.1583 2.45118 16.8417 2.64645 16.6464L8.64645 10.6464C8.84171 10.4512 9.15829 10.4512 9.35355 10.6464L13 14.2929L20.6464 6.64645C20.8417 6.45118 21.1583 6.45118 21.3536 6.64645Z"
          fill="#2D70E2"
        />
        <path
          id="Path 14 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.5 7C17.5 6.72386 17.7239 6.5 18 6.5H21.5V10C21.5 10.2761 21.2761 10.5 21 10.5C20.7239 10.5 20.5 10.2761 20.5 10V7.5H18C17.7239 7.5 17.5 7.27614 17.5 7Z"
          fill="#2D70E2"
        />
      </g>
    </svg>
  );
}

export function searchIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.5586 14.5586C14.7538 14.3633 15.0704 14.3633 15.2657 14.5586L20.8536 20.1464C21.0488 20.3417 21.0488 20.6583 20.8536 20.8536C20.6583 21.0488 20.3417 21.0488 20.1464 20.8536L14.5586 15.2657C14.3633 15.0704 14.3633 14.7538 14.5586 14.5586Z"
            fill="#666D79"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 10.5C4 6.91015 6.91015 4 10.5 4C14.0899 4 17 6.91015 17 10.5C17 14.0899 14.0899 17 10.5 17C6.91015 17 4 14.0899 4 10.5ZM10.5 5C7.46243 5 5 7.46243 5 10.5C5 13.5376 7.46243 16 10.5 16C13.5376 16 16 13.5376 16 10.5C16 7.46243 13.5376 5 10.5 5Z"
            fill="#666D79"
          />
        </g>
      </g>
    </svg>
  );
}

export function closeIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <g id="Vector">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.14272 6.14272C6.333 5.95243 6.64152 5.95243 6.83181 6.14272L17.8573 17.1682C18.0476 17.3585 18.0476 17.667 17.8573 17.8573C17.667 18.0476 17.3585 18.0476 17.1682 17.8573L6.14272 6.83181C5.95243 6.64152 5.95243 6.333 6.14272 6.14272Z"
            fill={fill}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.8573 6.14272C18.0476 6.333 18.0476 6.64152 17.8573 6.83181L6.83181 17.8573C6.64152 18.0476 6.333 18.0476 6.14272 17.8573C5.95243 17.667 5.95243 17.3585 6.14272 17.1682L17.1682 6.14272C17.3585 5.95243 17.667 5.95243 17.8573 6.14272Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
}

export function caretDown(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Path 3 (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.64645 9.64062C7.84171 9.45313 8.15829 9.45313 8.35355 9.64062L12 13.142L15.6464 9.64062C15.8417 9.45313 16.1583 9.45313 16.3536 9.64062C16.5488 9.82812 16.5488 10.1321 16.3536 10.3196L12 14.5L7.64645 10.3196C7.45118 10.1321 7.45118 9.82812 7.64645 9.64062Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export function addIcon(fill) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6C0 5.77909 0.179086 5.6 0.4 5.6H11.6C11.8209 5.6 12 5.77909 12 6C12 6.22091 11.8209 6.4 11.6 6.4H0.4C0.179086 6.4 0 6.22091 0 6Z"
        fill="#2D70E2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C6.22091 0 6.4 0.179086 6.4 0.4V11.6C6.4 11.8209 6.22091 12 6 12C5.77909 12 5.6 11.8209 5.6 11.6V0.4C5.6 0.179086 5.77909 0 6 0Z"
        fill="#2D70E2"
      />
    </svg>
  );
}

export function calendarIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector (Stroke)"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 2.5C7.27614 2.5 7.5 2.72386 7.5 3V4.5H16.5V3C16.5 2.72386 16.7239 2.5 17 2.5C17.2761 2.5 17.5 2.72386 17.5 3V4.5H19C20.3807 4.5 21.5 5.61929 21.5 7V19C21.5 20.3807 20.3807 21.5 19 21.5H5C3.61929 21.5 2.5 20.3807 2.5 19V7C2.5 5.61929 3.61929 4.5 5 4.5H6.5V3C6.5 2.72386 6.72386 2.5 7 2.5ZM5 5.5C4.17157 5.5 3.5 6.17157 3.5 7V8.5H20.5V7C20.5 6.17157 19.8284 5.5 19 5.5H5ZM20.5 9.5H3.5V19C3.5 19.8284 4.17157 20.5 5 20.5H19C19.8284 20.5 20.5 19.8284 20.5 19V9.5Z"
          fill="#666D79"
        />
      </g>
    </svg>
  );
}

export function trashIcon(fill) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.82422 6H5.82422H21.8242"
        stroke="#476DFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8242 6V20C19.8242 20.5304 19.6135 21.0391 19.2384 21.4142C18.8634 21.7893 18.3547 22 17.8242 22H7.82422C7.29379 22 6.78508 21.7893 6.41001 21.4142C6.03493 21.0391 5.82422 20.5304 5.82422 20V6M8.82422 6V4C8.82422 3.46957 9.03493 2.96086 9.41001 2.58579C9.78508 2.21071 10.2938 2 10.8242 2H14.8242C15.3547 2 15.8634 2.21071 16.2384 2.58579C16.6135 2.96086 16.8242 3.46957 16.8242 4V6"
        stroke="#476DFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8242 11V17"
        stroke="#476DFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8242 11V17"
        stroke="#476DFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}